<script>
import dayjs from 'dayjs';
import ClickOutside from './ClickOutside';
import IconHistory from './icons/History';

const DATE_FORMAT = 'YYYY-MM-DD';

const quickFilterOptions = [
  { text: 'текущая неделя', unit: 'week', shift: 0 },
  { text: 'текущий месяц', unit: 'month', shift: 0 },
  { text: 'текущий год', unit: 'year', shift: 0 },
  { text: 'предыдущая неделя', unit: 'week', shift: 1 },
  { text: 'предыдущий месяц', unit: 'month', shift: 1 },
  { text: 'предыдущий год', unit: 'year', shift: 1 },
];

export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      isDropdownShown: false,
    };
  },
  computed: {
    today () { return dayjs().format(DATE_FORMAT); },

    canShiftToThePast () {
      const { minDate, maxDate } = this.value;

      return Boolean(minDate) && Boolean(maxDate);
    },
    canShiftToTheFuture () {
      const { minDate, maxDate } = this.value;

      return Boolean(minDate) && Boolean(maxDate) && (maxDate < this.today);
    },
  },
  methods: {
    emitUpdate (newValue) {
      this.$emit('change', {
        ...this.value,
        ...newValue,
      });
    },

    handleMinDateInput (minDate) {
      if (minDate) {
        this.emitUpdate({ minDate });
      }
    },
    handleMaxDateInput (maxDate) {
      if (maxDate) {
        this.emitUpdate({ maxDate });
      }
    },
    handleShiftToThePast () {
      if (!this.canShiftToThePast) {
        return;
      }

      const minDate = dayjs(this.value.minDate);
      const maxDate = dayjs(this.value.maxDate);
      const shift = Math.max(1, maxDate.diff(minDate, 'day'));

      this.emitUpdate({
        minDate: minDate.subtract(shift, 'day').format(DATE_FORMAT),
        maxDate: maxDate.subtract(shift, 'day').format(DATE_FORMAT),
      });
    },
    handleShiftToTheFuture () {
      if (!this.canShiftToTheFuture) {
        return;
      }

      const minDate = dayjs(this.value.minDate);
      const maxDate = dayjs(this.value.maxDate);
      const todayDate = dayjs(this.today);
      const shift = Math.max(
        1,
        Math.min(
          maxDate.diff(minDate, 'day'),
          todayDate.diff(maxDate, 'day'),
        ),
      );

      this.emitUpdate({
        minDate: minDate.add(shift, 'day').format(DATE_FORMAT),
        maxDate: maxDate.add(shift, 'day').format(DATE_FORMAT),
      });
    },
    handleQuickSelect (e) {
      e.preventDefault();

      const { unit, shift } = e.target.dataset;

      if (!unit || !shift) {
        return;
      }

      this.emitUpdate({
        maxDate: dayjs()
          .endOf(unit)
          .subtract(shift, unit)
          .format(DATE_FORMAT),
        minDate: dayjs()
          .startOf(unit)
          .subtract(shift, unit)
          .format(DATE_FORMAT),
      });
      this.hideDropdown();
    },

    handleToggleDropdown () {
      this.isDropdownShown = !this.isDropdownShown;
    },

    hideDropdown () {
      this.isDropdownShown = false;
    },
  },
  render () {
    const { $style, value } = this;

    return (
      <div class={$style.wrapper}>
        <u-btn
          appearance="control"
          size="square"
          disabled={!this.canShiftToThePast}
          onClick={this.handleShiftToThePast}
        >
          <u-icon name="chevron-left" />
        </u-btn>
        <u-datepicker
          class={$style.datepicker}
          value={value.minDate}
          max={value.maxDate}
          closeOnSelect
          onInput={this.handleMinDateInput}
        />
        &nbsp;
        -
        &nbsp;
        <u-datepicker
          class={$style.datepicker}
          value={value.maxDate}
          min={value.minDate}
          max={this.tooday}
          closeOnSelect
          onInput={this.handleMaxDateInput}
        />
        <u-btn
          appearance="control"
          size="square"
          disabled={!this.canShiftToTheFuture}
          onClick={this.handleShiftToTheFuture}
        >
          <u-icon name="chevron-right" />
        </u-btn>

        <ClickOutside callback={this.hideDropdown}>
          <span class={$style.quickSelect}>
            <u-btn
              color="secondary"
              size="square"
              onClick={this.handleToggleDropdown}
            >
              <IconHistory />
            </u-btn>

            {this.isDropdownShown && (
              <u-dropdown onClick={this.handleQuickSelect}>
                {quickFilterOptions.map(({ text, shift, unit }) => (
                  <div key={`${unit}-${shift}`}>
                    <button
                      type="button"
                      class={[$style.quickSelectLink, 'link']}
                      data-shift={shift}
                      data-unit={unit}
                    >
                      {text}
                    </button>
                  </div>
                ))}
              </u-dropdown>
            )}
          </span>
        </ClickOutside>
      </div>
    );
  },
};
</script>

<style lang="scss" module>
@import '@/theme/include.scss';

.wrapper {
  align-items: center;
  display: inline-flex;
}

.datepicker {
  min-width: 120px;
  width: 120px;
}

.quickSelect {
  font-size: .825em;
  position: relative;
  text-align: right;
  white-space: nowrap;

  &Link {
    @include button-reset();

    line-height: 1.5;
  }
}

.quickSelect :global(.u-dropdown),
.wrapper :global(.u-datepicker .u-dropdown) {
  left: auto;
  right: 0;
}

.wrapper :global(.u-datepicker .u-dropdown) {
  min-width: 200px;
}
</style>
